import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textTransform',
  standalone: true,
})
export class TextTransformPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    mode: 'titlecase' | 'uppercase' | 'lowercase' | 'capitalize' = 'titlecase',
  ): string {
    if (!value) return '';

    switch (mode) {
      case 'titlecase':
        return value
          .replace(/\b\w/g, (char) => char.toUpperCase());

      case 'capitalize':
        if (!value) return value;
        return value.charAt(0).toUpperCase() + value.slice(1);

      case 'uppercase':
        return value.toUpperCase();

      case 'lowercase':
        return value.toLowerCase();

      default:
        return value;
    }
  }
}
